import { render } from "./TopProductsChart.vue?vue&type=template&id=34729a30"
import script from "./TopProductsChart.vue?vue&type=script&lang=js"
export * from "./TopProductsChart.vue?vue&type=script&lang=js"

import exportComponent from "/home/dyam/Documentos/PROYECTOS/JBN/mi-stock-jbn-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__